import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import { TransitionProps } from "@mui/material/transitions";
import { WhiteCloseIcon } from "../../../../assets/images";
import { EditBillOfMaterial } from "../../../../screens";


const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type AppProps = {
  isOpen: boolean;
  templateId: string;
  templateName: string;
  handleBOMTemplateModal: () => void;
};
const FullPageModal = ({
  isOpen,
  handleBOMTemplateModal,
  templateId,
  templateName,
}: AppProps) => {
  return (
    <div>
      <Dialog
        fullScreen
        open={isOpen}
        onClose={() => handleBOMTemplateModal()}
        TransitionComponent={Transition}
      >
        <AppBar
          sx={{
            position: "relative",
            backgroundColor: "#d8dee4",
            boxShadow: "none",
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => handleBOMTemplateModal()}
              aria-label="close"
            >
              <img src={WhiteCloseIcon} alt="close" />
            </IconButton>
            <Typography
              sx={{ ml: 2, flex: 1, color: "#262a44" }}
              variant="h6"
              component="div"
            >
              <div>{`${templateName}(${templateId})`}</div>
            </Typography>
          </Toolbar>
        </AppBar>
        <div className="pl-3">
          <EditBillOfMaterial templateId={templateId} bomType={"bomTemplate"}/>
        </div>
      </Dialog>
    </div>
  );
};

export default FullPageModal;
